import * as moment from 'moment';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from '@angular/core';

import { Account } from './../../model/account';
import { AccountInvoice } from '../../model/account-invoice';
import { AccountType } from './../../account-types.enum';
import { LoaderButtonState } from '../../../shared/components/button/button-status';

@Component({
  selector: 'ls-account-subscription',
  templateUrl: './account-subscription.component.html',
  styleUrls: [
    '../../containers/account.component.scss',
    './account-subscription.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSubscriptionComponent {
  @Input()
  public account: Account;
  @Input()
  public accountInvoices: Array<AccountInvoice>;
  @Input()
  public hasManagerAccess: boolean;
  @Input()
  public paymentRequestStatus: LoaderButtonState;
  @Output()
  public requestNewPayment: EventEmitter<AccountInvoice> = new EventEmitter();
  @ViewChild('payNow')
  public payNowButton: ElementRef;

  public accountType = AccountType;
  public readonly now: moment.Moment = moment();

  public requestPaymentUrl(): void {
    this.requestNewPayment.emit(this.accountInvoices[0]);
    this.payNowButton.nativeElement.disabled = true;
  }
}
